<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ (data?.id?'title.update-record':'title.new-record') | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">

  </button>
</div>

<div class="modal-body">
  <!-- Güncelleme  -->
  <div>
    <form #createForm="ngForm" class="needs-validation" novalidate>
      <!-- <h5>Firma Bilgisi</h5> -->
      <div class="card">

        <div class="card-body">

          <div class="row">
            <div class="col-sm-6">



              <div class="row form-group">
                <div class="col-sm-12">
                  <label class="custom-form-label">{{'address.addressTypeId' | translate}}</label>
                </div>
                <div class="col-sm-12">
                  <select #addressTypeId name="addressTypeId" [(ngModel)]="data.addressTypeId" class="form-control" required [class.is-invalid]="addressTypeId.invalid && addressTypeId.touched"
                    [disabled]="data?.id>0">
                    <option [ngValue]="1">{{'addressTypeValue.'+1 | translate}}</option>
                    <option [ngValue]="2">{{'addressTypeValue.'+2 | translate}}</option>
                    <option [ngValue]="3">{{'addressTypeValue.'+3 | translate}}</option>
                  </select>

                  <app-field-error-display [displayError]="addressTypeId.invalid && addressTypeId.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                  </app-field-error-display>
                </div>

              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <label class="custom-form-label">{{'address.categoryType' | translate}}</label>
                </div>
                <div class="col-sm-12">
                  <select #categoryTypeInput name="categoryTypeInput" [(ngModel)]="data.categoryType" class="form-control" required
                    [class.is-invalid]="categoryTypeInput.invalid && categoryTypeInput.touched">
                    <option *ngFor="let option of addressCategoryTypeEnumValues" [ngValue]="option">{{'addressCategoryTypeValue.'+option | translate}}</option>
                  </select>

                  <app-field-error-display [displayError]="categoryTypeInput.invalid && categoryTypeInput.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                  </app-field-error-display>
                </div>

              </div>

              <!-- Adres Başlığı -->
              <div class="row form-group" *ngIf="data.addressTypeId==3">
                <div class="col-sm-12">
                  <label class="custom-form-label"> {{'address.title' | translate}}</label>
                </div>
                <div class="col-sm-12">
                  <input #title="ngModel" type="text" class="form-control" name="title" [(ngModel)]="data.title" required [class.is-invalid]="title.invalid && title.touched" />
                  <app-field-error-display [displayError]="title.invalid && title.touched" errorMsg="title is reqired">
                  </app-field-error-display>
                </div>
              </div>

              <!-- il-İlçe-semt -->
              <!-- <div class="row form-group">
                <div class="col-sm-12">
                  <label class="custom-form-label">{{'address.city' | translate}} - {{'address.subProvince' | translate}}- {{'address.district' | translate}}</label>
                </div>
                <div class="col-sm-12">
                  {{data.cityName}} - {{data.subProvinceName}} - {{data.districtName}}
     
                  <div class="d-grid gap-2">
                    <button class="btn btn-primary " type="button" (click)="openSelectDistrictModal()">
                      {{'button.search-district' | translate}}
                    </button>
                  </div>
                </div>
              </div> -->



              <div class="col">
                <label class="custom-form-label" for="cityFullInput">{{'address.city' | translate}} - {{'address.subProvince' | translate}}- {{'address.district' | translate}}</label>

                <div class="input-group">
                  <div #cityFullInput class="form-control"> {{data.cityName}} - {{data.subProvinceName}} - {{data.districtName}}</div>
                  <div class="input-group-append">
                    <button class="btn btn-primary btn-input-group-append" type="button" (click)="openSelectDistrictModal()">
                      {{'button.select' | translate}}
                    </button>
                  </div>
                </div>
              </div>



            </div>


            <div class="col-sm-6">
              <!-- Adres -->
              <div class="row form-group">
                <div class="col-sm-12">
                  <label class="custom-form-label">{{'address.description' | translate}}</label>
                </div>
                <div class="col-sm-12">
                  <textarea type="text" #description="ngModel" name="description" [(ngModel)]="data.description" rows="3" class="form-control" appUppercase>
                  </textarea>
                </div>


              </div>

              <!-- Site -->
              <div class="row form-group">
                <div class="col-sm-12">
                  <label class="custom-form-label">{{'address.siteName' | translate}}</label>
                </div>
                <div class="col-sm-12">
                  <input type="text" class="form-control" name="siteName" [(ngModel)]="data.siteName" />
                </div>
              </div>

              <!-- Bina -->
              <div class="row form-group">
                <div class="col-sm-12">
                  <label class="custom-form-label">{{'address.buildingName' | translate}}</label>
                </div>
                <div class="col-sm-12">
                  <input type="text" class="form-control" name="buildingName" [(ngModel)]="data.buildingName" />
                </div>
              </div>

              <!-- Kapı Numarası -->
              <div class="row form-group">
                <div class="col-sm-12">
                  <label class="custom-form-label">{{'address.doorNum' | translate}}</label>
                </div>
                <div class="col-sm-12">
                  <input type="text" class="form-control" name="doorNum" [(ngModel)]="data.doorNum" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>

  <button type="button" [disabled]="createForm.form.invalid" class="btn btn-primary" (click)="save()">
    {{'button.save' | translate}}
  </button>
</div>